import { Button, Heading, Icon, Stack, Text } from '@eluve/components';

export type TemplateSavedViewProps = {
  name: string;
  onFillFromNote: () => void;
  onDone: () => void;
};

export const TemplateSavedView: React.FC<TemplateSavedViewProps> = ({
  name,
  onFillFromNote,
  onDone,
}) => (
  <Stack align="center" gap={6}>
    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-bg-indigo-subtle-primary">
      <Icon name="CheckCircle2" size="lg" className="text-text-indigo" />
    </div>

    <Stack align="center" gap={1}>
      <Heading size="lg">Template saved</Heading>
      <Text size="xs" color="tertiary" className="text-center">
        "{name}" is now in your PDF templates. Fill it from this note now, or
        any time later.
      </Text>
    </Stack>

    <Stack direction="horizontal" justify="center" gap={3}>
      <Button variant="ghost" onClick={onDone}>
        Done
      </Button>
      <Button variant="brandSecondary" onClick={onFillFromNote}>
        Fill from this note →
      </Button>
    </Stack>
  </Stack>
);
